<div [ngClass]="{ active: currentStep === step }" class="helpstep">
  <div class="stepnumber">
    {{ stepnumber }}
  </div>
  <div class="helpstep-title">
    {{ steptitle }}
  </div>
  <div class="helpstep-intro">
    {{ stepintro }}
  </div>
</div>
